// Copyright (c) 2026, 8848 Digital and contributors
// For license information, please see license.txt

frappe.provide("ms_teams_integration");

ms_teams_integration.schedule_meeting_button = function (frm, options = {}) {
	const group = options.group || __("Microsoft Teams");

	frm.add_custom_button(
		__("Schedule Teams Meeting"),
		() => ms_teams_integration.show_schedule_dialog(frm, options),
		group
	);

	if (frm.is_new()) return;

	frappe.call({
		method: "ms_teams_integration.microsoft_teams_integration.doctype.teams_meeting.api.get_meeting_for_reference",
		args: { reference_doctype: frm.doctype, reference_name: frm.docname },
		callback(r) {
			if (!r.message) return;
			frm.add_custom_button(
				__("View Teams Meeting"),
				() => ms_teams_integration.go_to_meeting_calendar(frm),
				group
			);
		},
	});
};

ms_teams_integration.go_to_meeting_calendar = function (frm) {
	frappe.route_options = {
		reference_doctype: frm.doctype,
		reference_name: frm.docname,
	};
	frappe.set_route("List", "Teams Meeting", "Calendar");
};

ms_teams_integration.show_schedule_dialog = function (frm, options = {}) {
	const dialog = new frappe.ui.Dialog({
		title: __("Schedule Teams Meeting"),
		fields: [
			{
				fieldname: "subject",
				fieldtype: "Data",
				label: __("Subject"),
				reqd: 1,
				default: options.default_subject || frm.doc.name,
			},
			{
				fieldname: "organizer",
				fieldtype: "Link",
				options: "User",
				label: __("Organizer"),
				reqd: 1,
				default: options.default_organizer || frappe.session.user,
				get_query: () => ({
					query: "ms_teams_integration.microsoft_teams_integration.doctype.teams_meeting.api.organizer_query",
				}),
			},
			{ fieldname: "column_break_1", fieldtype: "Column Break" },
			{
				fieldname: "starts_on",
				fieldtype: "Datetime",
				label: __("Starts On"),
				reqd: 1,
			},
			{
				fieldname: "ends_on",
				fieldtype: "Datetime",
				label: __("Ends On"),
				reqd: 1,
			},
			{ fieldname: "column_break_1", fieldtype: "Section Break" },
			{
				fieldname: "description",
				fieldtype: "Text Editor",
				label: __("Description"),
			},
			{
				fieldname: "section_break_attendees",
				fieldtype: "Section Break",
				label: __("Attendees"),
			},
			{
				fieldname: "attendees",
				fieldtype: "Table",
				label: __("Attendees"),
				fields: [
					{
						fieldname: "email_address",
						label: __("User"),
						fieldtype: "Link",
						options: "User",
						in_list_view: 1,
						reqd: 1,
					},
				],
			},
		],
		size: "large",
		primary_action_label: __("Schedule"),
		primary_action(values) {
			if (frappe.datetime.str_to_obj(values.ends_on) <= frappe.datetime.str_to_obj(values.starts_on)) {
				frappe.msgprint(__("End time must be after the start time."));
				return;
			}
			frappe.call({
				method: "frappe.client.insert",
				args: {
					doc: {
						doctype: "Teams Meeting",
						subject: values.subject,
						organizer: values.organizer,
						starts_on: values.starts_on,
						ends_on: values.ends_on,
						description: values.description,
						attendees: values.attendees || [],
						reference_doctype: frm.doctype,
						reference_name: frm.docname,
					},
				},
				freeze: true,
				freeze_message: __("Scheduling meeting on Microsoft Teams..."),
				callback(r) {
					if (r.exc || !r.message) return;

					const meeting = r.message;
					dialog.hide();

					if (meeting.sync_status === "Synced") {
						frappe.show_alert({
							message: __("Teams meeting scheduled successfully."),
							indicator: "green",
						});
					} else {
						frappe.show_alert({
							message: __("Could not schedule the meeting on Microsoft Teams: {0}", [
								meeting.sync_error || "",
							]),
							indicator: "red",
						});
					}

					options.callback && options.callback(meeting);
				},
			});
		},
	});

	dialog.show();
};
